import type { AppMeta } from "@calcom/types/App";

export const metadata = {
  name: "Giphy",
  description:
    "GIPHY is your top source for the best & newest GIFs & Animated Stickers online. Find everything from funny GIFs, reaction GIFs, unique GIFs and more.",
  installed: true,
  categories: ["other"],
  logo: "icon.svg",
  publisher: "ATEK",
  slug: "giphy",
  title: "Giphy",
  type: "giphy_other",
  url: "https://atek.io",
  variant: "other",
  extendsFeature: "EventType",
  email: "help@atek.io",
  dirName: "giphy",
  isOAuth: false,
} as AppMeta;

export default metadata;
